export default __webpack_public_path__ + "static/media/desktop.21d5a98f.mp4";